import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MPIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MP" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2993EC"
        fillRule="evenodd"
        d="M0 0h17v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F1F9FF"
        d="M8 1c2.703 0 4.893 2.146 4.893 4.792S10.703 10.583 8 10.583 3.106 8.438 3.106 5.792C3.106 3.146 5.297 1 8 1Zm0 1.042c-2.115 0-3.83 1.679-3.83 3.75 0 2.07 1.715 3.75 3.83 3.75s3.83-1.68 3.83-3.75c0-2.071-1.715-3.75-3.83-3.75Z"
      />
      <Path
        fill="#E31D1C"
        d="M8 1.417c2.467 0 4.468 1.959 4.468 4.375s-2 4.375-4.468 4.375-4.468-1.96-4.468-4.375c0-2.416 2-4.375 4.468-4.375Zm0 .208c-2.35 0-4.255 1.866-4.255 4.167 0 2.3 1.905 4.167 4.255 4.167 2.35 0 4.255-1.866 4.255-4.167 0-2.301-1.905-4.167-4.255-4.167Z"
      />
      <Path
        fill="#FDDA33"
        d="M3.042 4.885c.1.072.251.126.453.162.202.035.39.15.566.341a4.802 4.802 0 0 1-.615-.063c-.181-.032-.316-.179-.404-.44Zm9.085.083c.181-.032.358.06.53.275-.119-.034-.28-.033-.481.003-.202.035-.418-.007-.648-.128a4.8 4.8 0 0 1 .599-.15ZM3.405 3.834c.082.093.217.18.406.26.188.08.346.233.473.46a4.798 4.798 0 0 1-.584-.2c-.17-.073-.268-.246-.295-.52Zm8.389.185c.17-.072.363-.022.579.149-.123-.006-.28.031-.469.111-.188.08-.408.087-.659.022.197-.116.38-.21.549-.282Zm-7.78-1.133c.056.11.166.228.33.351.163.123.28.31.348.56a4.808 4.808 0 0 1-.518-.334c-.147-.111-.2-.304-.16-.577Zm7.23.287c.147-.111.347-.11.598.004-.122.024-.264.098-.428.221-.164.124-.376.184-.636.18.163-.159.319-.294.466-.405ZM4.82 2.108c.03.12.112.26.244.416.131.157.202.366.212.625a4.803 4.803 0 0 1-.43-.443c-.118-.141-.126-.341-.026-.598Zm5.693.364c.118-.14.313-.184.584-.13-.113.051-.236.155-.367.312-.132.157-.325.263-.579.318.123-.192.243-.358.362-.5Zm-4.726-.939c.003.124.05.277.144.46.093.183.115.401.067.656a4.81 4.81 0 0 1-.32-.528c-.083-.164-.047-.36.11-.588Zm4.388.165c-.099.075-.194.203-.287.386-.093.182-.258.33-.492.44.076-.215.156-.404.24-.568.083-.164.263-.25.539-.258Zm-3.3-.506c-.028.12-.02.28.026.48.046.2.015.418-.093.654-.08-.214-.14-.41-.182-.59-.041-.18.042-.36.248-.544Zm2.244.081c-.077.096-.14.245-.185.445-.047.2-.17.382-.371.546.022-.227.054-.43.095-.61.042-.18.195-.307.461-.38ZM8 1.104c-.054.112-.081.27-.081.475 0 .205-.08.41-.238.616a4.802 4.802 0 0 1-.044-.616c0-.184.12-.343.363-.475Z"
      />
      <Path
        fill="#A7A7A7"
        d="M8.813 2.875c.184 0 .32.17.28.349l-.193.883a.286.286 0 0 1-.13.182c.06.046.101.114.11.193l.695 5.824a.266.266 0 0 1-.129.264c-.26.15-.827.43-1.393.43-.566 0-1.132-.28-1.393-.43a.266.266 0 0 1-.129-.264l.694-5.824a.287.287 0 0 1 .11-.193.286.286 0 0 1-.129-.182l-.193-.883a.287.287 0 0 1 .28-.349h1.52Z"
      />
      <Path
        fill="#73BE4A"
        d="M3.26 6.006a.16.16 0 0 1 .199-.103.156.156 0 0 1 .106.195c-.045.143-.045.353.004.63a1.403 1.403 0 0 0 .107.347l.04.084a.773.773 0 0 1 .068.342.158.158 0 0 1-.16.156.158.158 0 0 1-.16-.156.47.47 0 0 0-.042-.218 6.558 6.558 0 0 0-.037-.079 1.6 1.6 0 0 1-.13-.423c-.057-.32-.057-.577.005-.775Z"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M8.106 8.09 6.05 9.49l.726-2.349L4.778 5.66l2.505-.05.823-2.318.823 2.318 2.506.05-1.997 1.482.726 2.35L8.106 8.09Z"
        clipRule="evenodd"
      />
      <Path
        fill="#73BE4A"
        d="M12.78 6.215a.16.16 0 0 0-.2-.104.156.156 0 0 0-.105.195c.044.143.044.354-.005.63a1.397 1.397 0 0 1-.146.432.773.773 0 0 0-.069.341c0 .086.072.156.16.156.088 0 .16-.07.16-.156a.47.47 0 0 1 .042-.217l.037-.08a1.607 1.607 0 0 0 .13-.422c.057-.32.057-.578-.004-.775Z"
      />
      <Path
        stroke="#73BE4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        d="M8.03 1.574s.583.26.331.667M8.456 1.574s.582.26.33.667"
      />
      <Path
        fill="#73BE4A"
        d="M4.63 3.178a.137.137 0 0 1 .198-.049.165.165 0 0 1 .045.216c-.08.14-.123.332-.123.579 0 .086-.064.156-.144.156-.079 0-.143-.07-.143-.156 0-.302.054-.55.167-.746Z"
      />
      <Path
        fill="#73BE4A"
        d="M4.404 4.606c0 .087-.064.157-.143.157-.08 0-.144-.07-.144-.157v-.445c0-.315.05-.563.154-.744a.137.137 0 0 1 .198-.05.164.164 0 0 1 .045.216c-.071.124-.11.317-.11.578v.445ZM11.742 4.398c0 .086.064.156.144.156.079 0 .143-.07.143-.156v-.445c0-.315-.05-.563-.153-.744a.137.137 0 0 0-.198-.05.165.165 0 0 0-.046.216c.072.124.11.317.11.578v.445Z"
      />
      <Path
        fill="#73BE4A"
        d="M12.168 5.127c0 .086.064.156.143.156.08 0 .144-.07.144-.156v-.445c0-.315-.05-.563-.154-.744a.137.137 0 0 0-.198-.05.164.164 0 0 0-.045.216c.071.124.11.317.11.578v.445Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
